<template>
	<div class="cpanel">
		<div class="icon">
			<span v-bind:class="classObject">{{splitMyName}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'myCircle',
		data() {
			return {
				myName: '',
				numberRom: ''
			};
		},
		props: {
			userName: String,
		},
		model: {
			prop: "userName"
		},
		mounted() {},
		watch: {

		},
		created() {
			this.numberRom = parseInt(Math.random() * 4)
			this.myName = this.userName
		},
		computed: {
			// 计算属性的 getter
			splitMyName: function() {
				// `this` 指向 vm 实例
				return this.myName.substring(this.myName.length - 2)
			},
			classObject: function() {
				if(this.numberRom == 0) {
					return {
						color0: true
					}
				} else if(this.numberRom == 1) {
					return {
						color1: true
					}
				} else if(this.numberRom == 2) {
					return {
						color2: true
					}
				} else {
					return {
						color3: true
					}
				}
			}
		}
	}
</script>

<style scoped>
	.cpanel div.icon span {
		-moz-transition-duration: 0.8s;
		/*background-color: #df41e1;*/
		background-position: -30px 50%;
		border: 1px solid #CCCCCC;
		border-radius: 15px;
		color: white;
		display: block;
		float: left;
		height: 30px;
		width: 30px;
		text-align: center;
		text-indent: 0;
		font-size: 15px;
		line-height: 30px;
	}
	
	.color0 {
		background-color: #82b3d4;
	}
	
	
	.color1 {
		background-color: #df41e1;
	}
	
	
	.color2 {
		background-color: #e89b15;
	}
	
	
	.color3 {
		background-color: #57b1b0;
	}
	
	
	.cpanel div.icon span:hover {
		border: 1px solid blue;
	}
</style>